$(function(){
    $(document).click(function(e){
      if($(e.target).parent().hasClass("sort_btn")){
          return;
      };
      
      $(".sortList").hide(0);
    })
    $(".sort_btn").click(function(){
      $(".sortList").toggle(0);
    })
  function hasClickEvent(button) {
      const events = $._data(button, 'events');
      return events && events.click && events.click.length > 0;
  }
  $(window).resize(function(){
    $('.sort_btn').each(function() {
        if (hasClickEvent(this)) {
            return;
        } else {
          $(".sort_btn").click(function(){
            $(".sortList").toggle(0);
          })      
        }
    });
  })
})